<!-- Breadcrumb Section Start -->
<section class="breadcrumb-section pt-0">
    <div class="container-fluid-lg">
        <div class="row">
            <div class="col-12">
                <div class="breadcrumb-contain">
                    <!-- <h2>Shop</h2> -->
                    <h2>
                        <li class="breadcrumb-item">
                            <a routerLink="/">
                                <i class="fa-solid fa-house"></i>
                            </a>
                        </li>
                        <li class="breadcrumb-item active">Shop</li>
                    </h2>
                    <nav>
                        <ol class="breadcrumb mb-0">

                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Shop Section Start -->
<section class="section-b-space shop-section">

    <div class="container-fluid-lg">
        <div class="row">
            <div class="col-custom-3 wow fadeInUp ">
                <div class="left-box left-box wow fadeInUp" [ngClass]=" siteBarshowHide ? 'show' : '' ">
                    <div class="shop-left-sidebar">
                        <div class="back-button">
                            <h3><i class="fa-solid fa-arrow-left" (click)="classHide()"></i> Back</h3>
                        </div>

                        <div class=" filter-category ">
                            <div class="filter-title ">
                                <h2>Filters</h2>
                                <!-- <a href="javascript:void(0) ">Clear All</a> -->
                            </div>

                        </div>

                        <div class="accordion custom-accordion " id="accordionExample ">
                            <div class="accordion-item ">
                                <h2 class="accordion-header " id="panelsStayOpen-headingOne ">
                                    <button class="accordion-button " type="button " data-bs-toggle="collapse " data-bs-target="#collapseOne ">
                    <span>Categories</span>
                  </button>
                                </h2>
                                <div id="collapseOne " class="accordion-collapse collapse show ">
                                    <div class="accordion-body ">
                                        <!-- <div class="form-floating theme-form-floating-2 search-box ">
                                            <input type="search " class="form-control " id="search " (keyup)="search($event) " placeholder="Search .. ">
                                            <label for="search ">Search</label>
                                        </div> -->

                                        <ul *ngIf="ResponseData?.length > 0; else noData" class="category-list custom-padding custom-height">
                                            <li *ngFor="let data of ResponseData">
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" [value]="data.id" id="fruit">
                                                    <label class="form-check-label" for="fruit">
                            <span class="name">{{ data?.subcategory_name ||"-"
                              }}</span>
                            <!-- <span class="number">(15)</span> -->
                          </label>
                                                </div>
                                            </li>

                                        </ul>
                                        <ng-template #noData>
                                            <div>
                                                <div class="title">

                                                    <h4>No data available!</h4>

                                                </div>

                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item" *ngFor="let data of attributeTerm; let i = index">
                                <h2 class="accordion-header" id="panelsStayOpen-heading{{ i }}">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapseFour' + i" aria-expanded="false" [attr.aria-controls]="'collapseFour' + i">
                    <span>{{ data?.name || "- " }}</span>
                  </button>
                                </h2>
                                <div id="collapseFour{{ i }}" class="accordion-collapse collapse" [attr.aria-labelledby]="'panelsStayOpen-heading' + i" data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        <ul class="category-list custom-padding">
                                            <li *ngFor="let terms of data?.terms">
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input (change)="onCheckboxChange(data.id, terms.id, $event)" class="checkbox_animated" type="checkbox" [id]="'flexCheckDefault' + i + '-' + terms.name">
                                                    <label class="form-check-label" [attr.for]="'flexCheckDefault' + i + '-' + terms.name">
                            <span class="name">{{ terms?.name || "-" }}</span>
                          </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <h2 class="accordion-header" id="panelsStayOpen-headingFive">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive">
                    <span>Price </span>
                  </button>
                                </h2>
                                <div id="collapseFive" class="accordion-collapse collapse show">
                                    <div class="accordion-body">
                                        <ul class="category-list custom-padding custom-height">
                                            <li *ngFor="let range of priceRanges; let i = index">
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" [id]="'flexCheckDefault' + i" (change)="onPriceRangeChange($event, range.value)" />
                                                    <label class="form-check-label" [for]="'flexCheckDefault' + i">
                            <span class="name">{{ range?.label }}</span>
                          </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                            <!-- <div class="accordion-item">
                                <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">
                    <span>Price</span>
                  </button>
                                </h2>
                                <div id="collapseThree" class="accordion-collapse collapse show">
                                    <div class="accordion-body">
                                        <div class="range-slider">
                                            <input type="text" class="js-range-slider" value>
                                        </div>
                                    </div>
                                </div>
                            </div> -->

                            <!-- <div class="accordion-item">
                                <h2 class="accordion-header" id="panelsStayOpen-headingFour">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour">
                    <span>Discount</span>
                  </button>
                                </h2>
                                <div id="collapseFour" class="accordion-collapse collapse show">
                                    <div class="accordion-body">
                                        <ul class="category-list custom-padding">
                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault">
                                                    <label class="form-check-label" for="flexCheckDefault">
                            <span class="name">upto 5%</span>
                            <span class="number">(06)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault1">
                                                    <label class="form-check-label" for="flexCheckDefault1">
                            <span class="name">5% - 10%</span>
                            <span class="number">(08)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault2">
                                                    <label class="form-check-label" for="flexCheckDefault2">
                            <span class="name">10% - 15%</span>
                            <span class="number">(10)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault3">
                                                    <label class="form-check-label" for="flexCheckDefault3">
                            <span class="name">15% - 25%</span>
                            <span class="number">(14)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault4">
                                                    <label class="form-check-label" for="flexCheckDefault4">
                            <span class="name">More than 25%</span>
                            <span class="number">(13)</span>
                          </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <h2 class="accordion-header" id="panelsStayOpen-headingFive">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive">
                    <span>Pack Size</span>
                  </button>
                                </h2>
                                <div id="collapseFive" class="accordion-collapse collapse show">
                                    <div class="accordion-body">
                                        <ul class="category-list custom-padding custom-height">
                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault5">
                                                    <label class="form-check-label" for="flexCheckDefault5">
                            <span class="name">400 to 500 g</span>
                            <span class="number">(05)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault6">
                                                    <label class="form-check-label" for="flexCheckDefault6">
                            <span class="name">500 to 700 g</span>
                            <span class="number">(02)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault7">
                                                    <label class="form-check-label" for="flexCheckDefault7">
                            <span class="name">700 to 1 kg</span>
                            <span class="number">(04)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault8">
                                                    <label class="form-check-label" for="flexCheckDefault8">
                            <span class="name">120 - 150 g each Vacuum 2
                              pcs</span>
                            <span class="number">(06)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault9">
                                                    <label class="form-check-label" for="flexCheckDefault9">
                            <span class="name">1 pc</span>
                            <span class="number">(09)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault10">
                                                    <label class="form-check-label" for="flexCheckDefault10">
                            <span class="name">1 to 1.2 kg</span>
                            <span class="number">(06)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault11">
                                                    <label class="form-check-label" for="flexCheckDefault11">
                            <span class="name">2 x 24 pcs Multipack</span>
                            <span class="number">(03)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault12">
                                                    <label class="form-check-label" for="flexCheckDefault12">
                            <span class="name">2x6 pcs Multipack</span>
                            <span class="number">(04)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault13">
                                                    <label class="form-check-label" for="flexCheckDefault13">
                            <span class="name">4x6 pcs Multipack</span>
                            <span class="number">(05)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault14">
                                                    <label class="form-check-label" for="flexCheckDefault14">
                            <span class="name">5x6 pcs Multipack</span>
                            <span class="number">(09)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault15">
                                                    <label class="form-check-label" for="flexCheckDefault15">
                            <span class="name">Combo 2 Items</span>
                            <span class="number">(10)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault16">
                                                    <label class="form-check-label" for="flexCheckDefault16">
                            <span class="name">Combo 3 Items</span>
                            <span class="number">(14)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault17">
                                                    <label class="form-check-label" for="flexCheckDefault17">
                            <span class="name">2 pcs</span>
                            <span class="number">(19)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault18">
                                                    <label class="form-check-label" for="flexCheckDefault18">
                            <span class="name">3 pcs</span>
                            <span class="number">(14)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault19">
                                                    <label class="form-check-label" for="flexCheckDefault19">
                            <span class="name">2 pcs Vacuum (140 g to 180 g each
                              )</span>
                            <span class="number">(13)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault20">
                                                    <label class="form-check-label" for="flexCheckDefault20">
                            <span class="name">4 pcs</span>
                            <span class="number">(18)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault21">
                                                    <label class="form-check-label" for="flexCheckDefault21">
                            <span class="name">4 pcs Vacuum (140 g to 180 g each
                              )</span>
                            <span class="number">(07)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault22">
                                                    <label class="form-check-label" for="flexCheckDefault22">
                            <span class="name">6 pcs</span>
                            <span class="number">(09)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault23">
                                                    <label class="form-check-label" for="flexCheckDefault23">
                            <span class="name">6 pcs carton</span>
                            <span class="number">(11)</span>
                          </label>
                                                </div>
                                            </li>

                                            <li>
                                                <div class="form-check ps-0 m-0 category-list-box">
                                                    <input class="checkbox_animated" type="checkbox" id="flexCheckDefault24">
                                                    <label class="form-check-label" for="flexCheckDefault24">
                            <span class="name">6 pcs Pouch</span>
                            <span class="number">(16)</span>
                          </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-custom- wow fadeInUp show">
                <div class="show-button">
                    <div class="filter-button-group mt-0">
                        <div class="filter-button d-inline-block d-lg-none">
                            <a (click)="classShow()"><i class="fa-solid fa-filter"  ></i> Filter Menu</a>
                        </div>
                    </div>

                    <div class="top-filter-menu">
                        <div class="category-dropdown">
                            <h5 class="text-content">Sort By :</h5>
                            <div class="dropdown">
                                <button class="dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown">
                  <span>{{ sortByHeading || 'Sort By' }}</span> <i
                    class="fa-solid fa-angle-down"></i>
                </button>
                                <ul class="dropdown-menu">
                                    <li>
                                        <a class="dropdown-item" id="pop" (click)="sortByProductData('most_popular')" href="javascript:void(0)">Most Popular</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" id="low" (click)="sortByProductData('low_to_high')" href="javascript:void(0)">Price - Low to High</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" id="high" (click)="sortByProductData('high_to_low')" href="javascript:void(0)">Price - High to Low</a>
                                    </li>
                                    <!-- <li>
                                        <a class="dropdown-item" id="rating" href="javascript:void(0)">Average
                      Rating</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" id="aToz" href="javascript:void(0)">A - Z Order</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" id="zToa" href="javascript:void(0)">Z - A Order</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" id="off" href="javascript:void(0)">% Off - Hight To
                      Low</a>
                                    </li> -->
                                </ul>
                            </div>
                        </div>

                        <div class="grid-option d-none d-md-block">
                            <ul>
                                <!-- <li class="three-grid">
                                    <a href="javascript:void(0)">
                                        <img src="assets/svg/grid-3.svg" class="blur-up lazyload" alt="">
                                    </a>
                                </li> -->
                                <li class="grid-btn d-xxl-inline-block d-none active">
                                    <a href="javascript:void(0)">
                                        <img src="assets/svg/grid-4.svg" class="blur-up lazyload d-lg-inline-block d-none" alt>
                                        <img src="assets/svg/grid.svg" class="blur-up lazyload img-fluid d-lg-none d-inline-block" alt>
                                    </a>
                                </li>
                                <!-- <li class="list-btn">
                                    <a href="javascript:void(0)">
                                        <img src="assets/svg/list.svg" class="blur-up lazyload" alt="">
                                    </a>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid-lg loader svr_loader_wrap" *ngIf="isLoading">
                    <div class="row ">
                        <div class="col-12 d-flex justify-content-center ">
                            <div class="spinner-border text-primary " role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isLoading && DataList.length; else emptyData" class="row g-sm-4 g-3 row-cols-xxl-4 row-cols-xl-4 row-cols-lg-2 row-cols-md-3 row-cols-2 product-list-section">
                    <div *ngFor="let product of DataList">
                        <div class="product-box-4 wow fadeInUp">
                            <div class="product-image">
                                <div class="label-flex">
                                    <div *ngIf="product.popular_status == 1" class="discount">
                                        <label>Most Popular</label>
                                    </div>
                                    <button *ngIf="product?.wishlist; else addWishList " class="btn p-0 wishlist btn-wishlist notifi-wishlist " (click)="removeToWishlist(product.id)">
                    <!-- <i class="iconly-Heart icli"
                      matTooltip="Click me to for view wishlist!"></i> -->
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="green"  matTooltip="Remove for wishlist!">
                        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                    </svg>
                  </button>

                                    <ng-template #addWishList>
                                        <button class="btn p-0 wishlist btn-wishlist notifi-wishlist">
                      <i (click)="addToWishlist(product.id)"
                        class="iconly-Heart icli"></i>
                    </button>
                                    </ng-template>
                                </div>

                                <ng-container>
                                    <!-- First condition -->
                                    <ng-container *ngIf="product.product_type == 0; else checkVariation">
                                        <a class="pointer" (click)="navigateToProductDetail(product,product.id, product.product_slug,'0')">
                                            <img [src]="imageBaseUrl + product.product_thumbnail ? imageBaseUrl + product.product_thumbnail : domiImageBaseUrl" class="img-fluid" alt />

                                        </a>
                                    </ng-container>

                                    <!-- Second condition -->
                                    <ng-template #checkVariation>
                                        <ng-container *ngIf="product.variations?.image?.image_path; else defaultThumbnail">
                                            <a class="pointer" (click)="navigateToProductDetail(product,product.id, product.product_slug,product.variations.variations_code)">
                                                <img [src]="imageBaseUrl + product.variations.image.image_path ? imageBaseUrl + product.variations.image.image_path : domiImageBaseUrl" class="img-fluid" alt />
                                            </a>
                                        </ng-container>
                                    </ng-template>

                                    <!-- Default condition -->
                                    <ng-template #defaultThumbnail>

                                        <a class="pointer" *ngIf="product.variations.variations_code; else defaultvariations" (click)="navigateToProductDetail(product,product.id, product.product_slug,product.variations.variations_code)">
                                            <img [src]="imageBaseUrl + product.product_thumbnail ? imageBaseUrl + product.product_thumbnail : domiImageBaseUrl" class="img-fluid" alt />
                                        </a>

                                        <ng-template #defaultvariations>

                                            <a class="pointer" (click)="navigateToProductDetail(product,product.id, product.product_slug,'0')">
                                                <img [src]="imageBaseUrl + product.product_thumbnail ? imageBaseUrl + product.product_thumbnail : domiImageBaseUrl" class="img-fluid" alt />
                                            </a>

                                        </ng-template>
                                    </ng-template>
                                </ng-container>
                            </div>

                            <div class="product-detail">
                                <a>
                                    <h5 class="name">{{ product.product_name }}</h5>
                                </a>
                                <div>

                                    <ng-container *ngIf="product.product_type == 0 ; else notVariation">
                                        <h5 class="price theme-color">
                                            ₹{{ product.discount_price || product.selling_price}}
                                        </h5>
                                    </ng-container>
                                    <ng-template #notVariation>
                                        <h5 class="price theme-color">
                                            ₹{{ product.variations.discount_price|| product.variations.variations_price}}
                                        </h5>
                                    </ng-template>

                                </div>

                                <!-- Show 'Out of Stock' if product_stock is 0 or variations.stock is unavailable -->
                                <div class="price-qty" *ngIf="product?.product_stock == 0 || (product.variations?.stock == '0'); else inStock">
                                    <p>Out of Stock</p>
                                </div>

                                <!-- In-Stock Template -->
                                <ng-template #inStock>
                                    <!-- Show 'Go to Cart' if product is already in the cart -->
                                    <span *ngIf="product?.cart; else addToCart">
                    <button class="buy-button buy-button-2 btn svr_GotoCart">
                      <!-- <span class="svr_ViewCart" [routerLink]="['/users/account/cart']">View Cart</span> -->
                                    <!-- <i class="iconly-Buy icli text-white m-0"
                            [routerLink]="['/users/account/cart']"></i> -->
                                    <i class="fa fa-eye icli text-white m-0" [routerLink]="['/users/account/cart']" matTooltip="Click me to for view cart!"></i>

                                    </button>
                                    </span>

                                    <!-- Template for "Add to Cart" -->
                                    <ng-template #addToCart>
                                        <button *ngIf="product.product_type == 1 ;else variantCart" (click)="openModal(product)" class="buy-button buy-button-2 btn">
                                        <i class="iconly-Buy icli text-white m-0"></i>
                                      </button>

                                        <ng-template #variantCart>
                                            <button (click)="addToCartData(product.id, 1, product.variations? product.variations.discount_price || product.variations.variations_price : product.discount_price?  product.discount_price:product.selling_price, product.product_type, product.variations ? product.variations.id : '')"
                                                class="buy-button buy-button-2 btn">
                                          <i class="iconly-Buy icli text-white m-0"></i>
                                        </button>
                                        </ng-template>

                                    </ng-template>
                                </ng-template>

                            </div>
                        </div>
                    </div>
                    <div id="myModal" class="modal" [ngClass]="{'show': isModalOpen}" (click)="closeModal($event)">

                        <!-- Modal content -->
                        <div class="modal-content" (click)="stopPropagation($event)">
                            <div class="modal-header">
                                <h2>Product Details</h2>
                                <span class="close" (click)="closeModal($event)">&times;</span>

                            </div>
                            <div class="modal-body">
                                <div class="product-section">
                                    <div class="right-box-contain">
                                        <div class="note-box product-package">
                                            <!-- <img [src]="imageBaseUrl + firstVariationImagePath.image_path ? imageBaseUrl + firstVariationImagePath.image_path : domiImageBaseUrl" class="img-fluid" alt /> -->
                                            <div class="product-package-img">
                                                <img [src]="imageBaseUrl + firstVariationImagePath ? imageBaseUrl + firstVariationImagePath : domiImageBaseUrl" class="img-fluid" alt /> </div>
                                            <div class="product-package-info">
                                                <div class="price-rating">
                                                    <div class="theme-color price">
                                                        <h3>₹{{ price ||'' }}</h3>
                                                    </div>
                                                </div>
                                                <div class="product-package" *ngFor="let attributeData of attrVariationDataList?.attributeTermData">
                                                    <div class="product-title">
                                                        <h4>{{ attributeData.name }}</h4>
                                                    </div>
                                                    <ul class="select-package">
                                                        <li *ngFor="let termData of attributeData.terms">
                                                            <a href="javascript:void(0)" [ngClass]="{ 'active': activeTerms[attributeData.id] === termData.id }" (click)="setActiveTerm(attributeData.id, termData.id)">
                                  {{ termData.name }}
                                </a>
                                                        </li>
                                                    </ul>

                                                </div>
                                                <div class="product-qty-box">
                                                    <div class="cart_qty qty-box product-qty">
                                                        <div class="input-group">
                                                            <button type="button" (click)="plusMinusQuantity('minus')" class="qty-left-minus" data-type="minus" data-field>
                                <i class="fa fa-minus"></i>
                              </button>
                                                            <input class="form-control input-number qty-input" type="text" name="quantity" value="{{ quantity }}">
                                                            <button type="button" (click)="plusMinusQuantity('plus')" class="qty-right-plus" data-type="plus" data-field>
                                <i class="fa fa-plus"></i>
                              </button>
                                                        </div>
                                                    </div>
                                                    <button (click)="addToCartData(product.id, quantity,price, product.product_type, variant_id ? variant_id : '')" class="btn btn-md bg-dark cart-button text-white w-100">
                                                      <span *ngIf="!isCartLoading">Add To Cart</span>
                                                      <span *ngIf="isCartLoading"
                                                        class="spinner-border spinner-border-sm spinner-grow flex-shrink-0"
                                                        role="status" aria-hidden="true">
                                                        <p> Loading..</p></span>

                                                    </button>


                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                        <button type="submit" class="btn btn-animation">
              </button>
                        <!-- <div class="modal-footer">
            <h3>update</h3>
        </div> -->

                    </div>
                </div>
                <nav class="custom-pagination" *ngIf="!isLoading && DataList.length > 0">
                    <ul class="pagination justify-content-center">
                        <!-- Previous Button -->
                        <li class="page-item" [class.disabled]="pagination.page === 0">
                            <a class="page-link" href="javascript:void(0)" (click)="onPageChange(pagination.page - 1)">
                                <i class="fa-solid fa-angles-left"></i>
                            </a>
                        </li>

                        <!-- Page Numbers -->
                        <li class="page-item" *ngFor="let page of [].constructor(totalPages); let i = index" [class.active]="pagination.page === i">
                            <a class="page-link" href="javascript:void(0)" (click)="onPageChange(i)">
                {{ i + 1 }}
              </a>
                        </li>

                        <!-- Next Button -->
                        <li class="page-item" [class.disabled]="pagination.page === totalPages - 1">
                            <a class="page-link" href="javascript:void(0)" (click)="onPageChange(pagination.page + 1)">
                                <i class="fa-solid fa-angles-right"></i>
                            </a>
                        </li>
                    </ul>
                </nav>
                <ng-template #emptyData>
                    <div class="container-fluid-lg" *ngIf="!isLoading">
                        <div class="title">

                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <div class="svr_nodata">
                                    <h4>No data available!</h4>
                                    <p>There is no data to show you right now</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</section>
<!-- Shop Section End -->